<template>
  <div id="evaluate-company">
    <evaluator-header class="mainHeader" @logout="logoutClick"></evaluator-header>
    <div class="wrapper">
      <!--<div class="section section1" @click="testAddressClick">-->
      <!--<div class="title">风险评测</div>-->
      <!--</div>-->
      <div class="section section2">
        <div class="image"></div>
      </div>
      <div class="section section3">
        <div class="title">企业信息</div>
        <!--<div class="rightBtn" v-show="!showImage&&closeImage===0" @click="showComImage">营业执照识别</div>-->
        <!--<div class="box box1" v-show="showImage">-->
        <!--<div class="tip">营业执照</div>-->
        <!--<input-->
        <!--class="input-image"-->
        <!--type="file"-->
        <!--:disabled="binImage"-->
        <!--@click="imageClick"-->
        <!--@change="imageChange"-->
        <!--accept="*.jpg, *.png, *.jpeg"-->
        <!--/>-->
        <!--<div class="image" v-show="imageUrl.length <= 0"></div>-->
        <!--<div-->
        <!--class="image"-->
        <!--v-show="imageUrl.length > 0"-->
        <!--:style="{backgroundImage:'url('+ resourceUrl + imageUrl+')'}"-->
        <!--&gt;</div>-->
        <!--<div class="tip2">-->
        <!--请上传扫描或相机拍摄营业执照，保证营业执照上-->
        <!--<span>信息清晰可见</span>，图片大小不超过2M，文件格式为bmp、jpg、jpeg格式-->
        <!--</div>-->
        <!--<div class="example" @click="showExampleImageClick">-->
        <!--<img src="../assets/icon_eva_search.png" />-->
        <!--<span>查看示例图</span>-->
        <!--</div>-->
        <!--</div>-->
        <div class="box">
          <div class="tip">企业名称</div>
          <input type="text" v-model="companyName" :disabled="binCompanyName" @blur="companyNameBlur()"
            v-on:focus="focus()" placeholder="请输入企业名称" />
        </div>
        <div class="box" v-on:click="addressClick">
          <div class="tip">企业所在地</div>
          <input :hidden="haveAddress" disabled type="text" v-model="address" readonly="readonly" unselectable="on"
            placeholder="请选择企业所在地" />
          <Dropdown v-show="haveAddress" class="address-menu" trigger="click" @on-click="changeAddress">
            <a href="javascript:void(0)">{{address}}</a>
            <Dropdown-menu slot="list">
              <Dropdown-item v-for="(value,index) in companyNameData" :name="index" :key="index">{{value.address}}
              </Dropdown-item>
            </Dropdown-menu>
          </Dropdown>
        </div>
        <div class="box" v-on:click="townClick" v-show="haveTown">
          <div class="tip">所在街道</div>
          <input class="code" disabled v-model="town" type="text" placeholder="请选择所在街道" v-on:blur="blur()"
            v-on:focus="focus()" />
        </div>
        <div class="box">
          <div class="tip">企业详细地址</div>
          <input class="code" :disabled="binDetailAddress" v-model="detailAddress" type="text" placeholder="请输入企业办公地址"
            v-on:blur="blur()" v-on:focus="focus()" />
        </div>
        <div class="box">
          <div class="tip">联系人手机号</div>
          <input :hidden="havePhone" type="text" maxlength="11" v-model="fphone" :disabled="binPhone"
            placeholder="请输入联系人手机号" v-on:blur="blur()" v-on:focus="focus()" />
          <Dropdown v-show="havePhone" class="phone-menu" trigger="click" @on-click="changePhone">
            <a href="javascript:void(0)">
              <div v-show="havePhone&&phone===''">请输入联系人手机号</div>
              {{fphone}}
            </a>
            <Dropdown-menu slot="list">
              <Dropdown-item v-for="(value,index) in companyNameData" :name="index" :key="index">{{value.fphone}}
              </Dropdown-item>
            </Dropdown-menu>
          </Dropdown>
          <div :style="{backgroundColor:time?'#C41335':'#FECDCD'}" class="codebtn" id="codeText" @click="codeClick">
            获取验证码</div>
        </div>
        <div class="box">
          <div class="tip">验证码</div>
          <input class="code" :disabled="binCode" v-model="code" oninput="value=value.replace(/[^\d]/g,'')"
            maxlength="6" type="text" placeholder="请输入验证码" v-on:blur="blur()" v-on:focus="focus()" />
        </div>
      </div>
    </div>
    <bottomButton id="bottomButton" title="开始评测" :state="bottomState" @click="bottomClick"></bottomButton>
    <!--  评测进度提示  -->
    <AlertView :show="showAlert" title :subTitle="alerViewTitle" cancelTitle="取消" :sureTitle="alertSureTitle"
      @alertViewClick="alertViewClick"></AlertView>
    <!--  营业执照提示  -->
    <!--<AlertView-->
    <!--:show="showAlert2"-->
    <!--title-->
    <!--:subTitle="alerViewTitle2"-->
    <!--:cancelTitle="alertCancelTitle2"-->
    <!--:sureTitle="alertSureTitle2"-->
    <!--@alertViewClick="alertViewClick2"-->
    <!--&gt;</AlertView>-->
    <!--  营业执照实例  -->
    <!--<mt-popup v-model="imageVisible" position="center" class="image-popup">-->
    <!--<div class="image-example">-->
    <!--<div class="e-image">-->
    <!--<div class="e-image-close" @click="closeExampleImageClick"></div>-->
    <!--<img src="../assets/icon-image-example.jpg" />-->
    <!--</div>-->
    <!--</div>-->
    <!--</mt-popup>-->
    <!--  地址选择  -->
    <AreaView :show="addressVisible" @selectedArea="selectedArea"></AreaView>
    <SPicker :show="townVisible1" type="1" @selectedSPicker="selectedSPicker1"></SPicker>
    <SPicker :show="townVisible2" type="7" @selectedSPicker="selectedSPicker2"></SPicker>
    <div id="captcha" :class="captchaConfig.config.product === 'bind' ? 'hideHeight' : ''">
      <AliCaptcha :captcha-config="captchaConfig" />
    </div>
  </div>
</template>
<script>
import evaluatorHeader from '../view/evaluator-header'
import bottomButton from '../components/bottom-button'
// import Address from '../components/adress_list'
import AreaView from '../components/area-view'
import AlertView from '../components/alert-view'
import SPicker from '../components/single-picker'
import { Toast } from 'mint-ui'
import wxShare from '../wx/weixin.js'
import AliCaptcha from '../components/aliCaptcha.vue'
export default {
  data () {
    const captchaHandler = (captchaObj) => {
      window.captchaObj = captchaObj;
      captchaObj
      .appendTo("#captcha")
      .onReady(function () {
        console.log("ready");
      })
      .onNextReady(function () {
        console.log("nextReady");
      })
      .onBoxShow(function () {
        console.log("boxShow");
      })
      .onError(function (e) {
        console.log(e);
      })
      .onSuccess(() => {
        console.log(window._vueInstance,'window._vueInstance')
        if (window._vueInstance && window._vueInstance.captchaConfig.config.product === "bind") {
          window._vueInstance.validate();
        }
      });
    };
    return {
      riseProgress: -1, // 风险 评测进度 -1 未评测  0 评测 初始化 去企业信息  1 去选择场所 2 去答题  3 去评测  4 查看评测结果
      showImage: 0, // 营业执照
      closeImage: 1, //  营业执照 认证 0 开启 1 关闭
      showAlert: false,
      alerViewTitle: '',
      alertSureTitle: '',
      showAlert2: false,
      alerViewTitle2: '',
      alertCancelTitle2: '',
      alertSureTitle2: '',
      resultId: '', // 评测结果id
      unfinishedCategoryIds: '', // 未答题的id
      imageVisible: false,
      addressVisible: false,
      townVisible1: false,
      townVisible2: false,
      isLogin: false, // 是否 登录状态
      resourceUrl: this.utils.ResourceUrl,
      imageUrl: '', // 营业执照
      companyName: '',
      address: '',
      addressCode: '',
      province: '',
      city: '',
      region: '',
      town: '', // 街道
      detailAddress: '',
      phone: '',
      fphone: '',
      code: '',
      havePhone: false, // 未登录 状态查询企业 是否有用户
      haveAddress: false, // 未登录  有地址信息
      haveTown: false,
      Town: 1, // 街道 1or2 可编辑
      binPhone: false, // 电话号码 可编辑
      binAddress: true, // 地址 是否可编辑 登录状态
      binDetailAddress: true, // 详细地址
      binCompanyName: false, // 编辑企业名称
      binImage: false, // 选择 营业 执照
      binCode: true, // 可编辑 验证码
      binTown: false, // 湖北省 下陆区 可编辑
      currentIndex: 0,
      companyNameData: [], // 根据企业名称 查询企业信息
      userCompanyData: {}, // 登录用户查询 企业信息
      timer: '',
      ableBottom: 1, // 按钮连续点击,
      time: 0, // 1 获取验证码可以点击 0 置灰
      bottomStates: 0, // 底部开始评测按钮可点击
      captchaConfig: {
        config: {
          captchaId: "347c38155fea93f1450cab541186c39f",
          language: "zho",
          product: "bind",
        },
        handler: captchaHandler,
      },
    }
  },
  watch: {
    $router () {
    },
    code: function (val) {
      var _this = this
      if (/^\d{6}$/.test(this.code)) {
        this.utils.POSTQS(this.accountUrl + '/account/verifyCode?phone=' + this.phone + '&code=' + this.code, false, null, function (response) {
          if (response.data.data === '验证码已过期，请点击重新发送') {
            Toast('验证码已过期，请点击重新发送')
          } else if (response.data.data === false) {
            Toast('验证码输入错误')
          } else {
            _this.bottomStates = 1
          }
        })
      }
      console.log(_this.bottomStates)
    },
    phone: function (val) {
      if (val > 11) {
        this.phone = val.slice(0, 11)
      }
    }
  },
  computed: {
    bottomState: function () { // 底部按钮状态
      if (!this.utils.isNull(this.companyName) && !this.utils.isNull(this.region) &&
        !this.utils.isNull(this.phone) && this.bottomStates === 1) {
        return 1
      }
      return 0
    }
  },
  components: {
    evaluatorHeader,
    bottomButton,
    AreaView,
    AlertView,
    SPicker,
    AliCaptcha
  },
  mounted () {
    window._vueInstance = this;
    this.loadData()
    this.loadBaidu()
    // 微信 分享
    let imgUrl = 'http://cdn.zxzx119.com/39073939414056960'
    wxShare.wxRegister('消防安全风险评测', '中消在线风险评测  一站式解决企业风险隐患', imgUrl)
    // 统计
    this.utils.listenEvent(7, '', window.location.href, '')
  },
  destroyed () {
    if (this.timer) {
      clearInterval(this.timer)
      document.getElementById('codeText').innerText = '获取验证码'
    }
  },
  methods: {
    // testAddressClick: function () {
    //
    // },
    logoutClick: function () { // 退出登录
      this.$router.push({ path: 'home' })
    },
    focus: function () {
      if (!this.utils.isIphone()) {
        document.getElementById('bottomButton').style.display = 'none'
      }
    },
    blur: function () {
      if (this.utils.isIphone()) { // iphone 适配键盘 弹出 回弹
        const currentScrollY = window.scrollY
        window.scrollTo(0, currentScrollY)
      } else {
        document.getElementById('bottomButton').style.display = 'block'
      }
      if (this.binPhone === false) {
        this.phone = this.fphone
      }
      if (this.isLogin) {
        if (this.detailAddress !== '') {
          this.bottomStates = 1
        } else {
          this.bottomStates = 0
        }
        this.time = 0
      } else {
        if (/^1[3456789]\d{9}$/.test(this.phone)) {
          this.time = 1
        } else {
          this.time = 0
        }
      }
    },
    // imageClick: function () {
    // },
    // getType: function (file, success) {
    //   var type = 1
    //   var reader = new FileReader()
    //   reader.onload = function (e) {
    //     var data = e.target.result
    //     // 加载图片获取图片真实宽度和高度
    //     var image = new Image()
    //     image.onload = function () {
    //       var width = image.width
    //       var height = image.height
    //       if (width > height) {
    //         type = 2
    //       } else {
    //         type = 1
    //       }
    //       success(type)
    //     }
    //     image.src = data
    //   }
    //   reader.readAsDataURL(file)
    // },
    // imageChange: function (event) {
    //   console.log(event)
    //   var _this = this
    //   // 上传图片 并返回 企业信息
    //   var file = event.target.files[0]
    //   // 1 竖屏 2 横屏
    //   this.getType(file, function (type) {
    //     console.log('type-------------' + type)
    //     let param = new FormData()
    //     param.append('imgFile', file)
    //     param.append('type', type)
    //     console.log(param)
    //     _this.utils.POSTHeader(_this.accountUrl + '/riskeval/upload_file_qiniu', { 'content-type': 'multipart/form-data' }, param, function (response) {
    //       let code = parseInt(response.code)
    //       let data = response.data
    //       if (code === 50005) { // 营业执照图片读取失败
    //         console.log('=========000000000=========' + _this.isLogin)
    //         if (_this.isLogin === false) { // 登录状态下 营业执照必填
    //           _this.showAlert2 = true
    //           _this.alerViewTitle2 = '您提交的营业执照无法识别，请重新上传'
    //           _this.alertCancelTitle2 = '手动输入'
    //           _this.alertSureTitle2 = '重新上传'
    //         }
    //       }
    //       if (code === 50006) { // 当前营业执照认证的用户与登陆的用户不一致
    //       }
    //       if (code === 50007) { // 企业名称认证失败
    //       }
    //       if (code === 50009) { // 企业识别异常，吊销、注销、清算、停止
    //       }
    //       if (code === 0) { // 成功返回
    //         _this.imageUrl = data.fileId
    //         // if (!_this.utils.isNull(data.info.province)) {
    //         //   _this.province = data.info.province
    //         //   _this.city = data.info.city
    //         //   _this.region = data.info.area
    //         //   _this.address = data.info.province + ' ' + data.info.city + ' ' + data.info.area
    //         // }
    //         // this.address = ''
    //         if (!_this.utils.isNull(data.info.province)) {
    //           _this.province = data.info.province
    //           _this.address = data.info.province
    //         }
    //         if (!_this.utils.isNull(data.info.city)) {
    //           _this.city = data.info.city
    //           _this.address += (' ' + data.info.city)
    //         }
    //         if (!_this.utils.isNull(data.info.region)) {
    //           _this.region = data.info.region
    //           _this.address += (' ' + data.info.region)
    //         }
    //         _this.binAddress = false
    //         if (!_this.utils.isNull(data.info.province) && !_this.utils.isNull(data.info.city) && !_this.utils.isNull(data.info.region)) {
    //           _this.binAddress = true
    //         }
    //
    //         _this.companyName = data.info.company_name
    //         if (_this.companyName.length > 0) {
    //           if (_this.isLogin === false) { // 未登录状态下 查询企业用户信息
    //             _this.companyNameBlur()
    //           }
    //         }
    //         // 判断 是否 编辑验证码
    //         if (_this.companyName === _this.userCompanyData.company_name) {
    //           _this.binCode = true
    //         } else {
    //           _this.binCode = false
    //         }
    //       }
    //     })
    //   })
    // },
    codeClick: function () { // 获取验证码
      // if (this.isLogin === true) {
      //   if (this.binCode === true) {
      //     Toast('登录状态下，可不验证，直接进行"下一步"')
      //     return
      //   }
      // }
      // if (this.showImage === true) {
      //   if (this.utils.isNull(this.imageUrl)) {
      //     Toast('请上传营业执照')
      //     return false
      //   }
      // }
      if (this.time === 1) {
        if (this.utils.isNull(this.companyName)) {
          Toast('请输入企业名称')
          return
        }
        if (this.utils.isNull(this.region)) {
          Toast('请输入完整企业所在地')
          return
        }
        if (this.utils.isNull(this.detailAddress)) {
          Toast('请输入企业详细地址')
          return
        }
        if (this.utils.isNull(this.phone)) {
          Toast('请输入联系方式')
          return
        }
        if (!this.utils.isPhone(this.phone)) {
          Toast('请正确输入联系方式')
          return
        }
        if (!window.captchaObj) {
          alert('请等待验证初始化完成');
          return;
        }
        if (this.captchaConfig.config.product === 'bind') {
          // bind模式：弹出验证框，验证成功后由 onSuccess 回调触发 validate
          window.captchaObj.showCaptcha();
        } else {
          // 非bind模式：直接获取验证结果后发送短信
          this.validate();
        }
      }
    },
    validate () {
      let result = window.captchaObj.getValidate();
      if (!result) {
        alert('请先完成验证！');
        return;
      }
      var _this = this
      this.utils.POSTQS(this.accountUrl + 
        '/riskeval/sendCode?phone=' + 
        this.phone + '&company_name=' + 
        this.companyName + '&captchaOutput=' + 
        result.captcha_output + '&genTime=' +
        result.gen_time + '&lotNumber' + 
        result.lot_number + '&passToken=' + result.pass_token, false, null, function (response) {
        console.log('========短信发送成功')
        if (parseInt(response.code) === 0) {
          _this.countDown()
        }
        _this.binCode = false
      })
    },
    countDown: function () { // 倒计时
      console.log('倒计时==========')
      var _this = this
      var maxtime = 60
      this.timer = setInterval(function () {
        if (maxtime > 0) {
          --maxtime
          _this.time = 0
          document.getElementById('codeText').innerText = maxtime + 's'
        } else {
          clearInterval(_this.timer)
          _this.time = 1
          document.getElementById('codeText').innerText = '获取验证码'
        }
      }, 1000)
    },
    changePhone: function (key) {
      this.currentIndex = key
      let info = this.companyNameData[this.currentIndex]
      this.phone = info.phone
      this.fphone = info.fphone
      console.log('----------------===' + key + '====' + this.phone)
      if (!this.utils.isNull(info.province)) {
        this.province = info.province
        this.city = info.city
        this.region = info.region
        this.town = info.town
        this.address = this.province + ' ' + this.city + ' ' + this.region + ' ' + this.town
      }
    },
    // formmaterPhone: function (phone) {
    //   if (phone.length >= 11) {
    //     return phone.replacableOptionKeys
    //   }
    // },
    showAddress: function () {
      console.log('=============================地址')
      let have = this.companyNameData[this.currentIndex].haveAddress
      if (have === 1) {
        return true
      }
      return false
    },
    changeAddress: function (key) {
      this.currentIndex = key
      let info = this.companyNameData[this.currentIndex]
      if (info.haveAddress === 0) {
        this.addressClick()
        return
      }
      this.province = info.province
      this.city = info.city
      this.region = info.region
      this.address = info.province + ' ' + info.city + ' ' + info.region + ' ' + info.town
      this.phone = info.phone
      this.fphone = info.fphone
    },
    addressClick: function () {
      // 登录状态下  如果 有地址信息 不可修改
      console.log('点击选择地址----------')
      if (this.isLogin === false) { // 未登录状态
        this.binDetailAddress = false
        if (this.binAddress === true) { // 未选择营业执照
          return
        }
        if (this.companyNameData.length > 0) {
          let info = this.companyNameData[this.currentIndex]
          console.log(info)
          if (info.haveAddress === 1) { // 有地址 选择地址
            this.addressVisible = false
          } else {
            this.addressVisible = true
          }
        } else {
          this.addressVisible = true
        }
      }
      if (this.isLogin === true) { // 登录状态下 选择地址
        if (this.binAddress === false) {
          this.addressVisible = true
        }
      }
    },
    selectedArea: function (province, city, area, code) {
      if (code === 0) {
        this.addressVisible = false
        return
      }
      this.addressVisible = false
      this.province = province
      this.city = city
      this.region = area
      this.address = province + ' ' + city + ' ' + area
      this.addressCode = code
      this.haveTown = false
      this.binTown = true
      this.town = ''
      if (area === '下陆区') {
        this.haveTown = true
        this.binTown = false
      }
      if (area === '西塞山区') {
        this.haveTown = true
        this.Town = 2
        this.binTown = false
      }
    },
    townClick: function () {
      if (this.haveTown === true && this.binTown === false && this.Town === 1) {
        this.townVisible1 = true
      }
      if (this.haveTown === true && this.binTown === false && this.Town === 2) {
        this.townVisible2 = true
      }
    },
    selectedSPicker1: function (value) {
      this.townVisible1 = false
      if (!this.utils.isNull(value)) {
        this.town = value
      }
    },
    selectedSPicker2: function (value) {
      this.townVisible2 = false
      if (!this.utils.isNull(value)) {
        this.town = value
      }
    },
    startRise: function (info) {
      var _this = this
      this.utils.POSTQS(this.accountUrl + '/riskeval/saveUserData', false, info, function (response) {
        if (parseInt(response.code) === 0) {
          console.log('去评测========================')
          _this.$router.push({ path: 'evaluate-category2' })
        }
      })
    },
    bottomClick: function () { // 下一步 提交企业信息
      console.log('=======================下一步======')
      if (this.bottomStates === 1) {
        if (this.isLogin === false) {
          let data = { 'data': { 'tails': { 'userinfo': [{ 'phone': this.phone }] } } }
          localStorage.setItem('userinfo', JSON.stringify(data.data))
        }
        var _this = this
        if (this.checkCompanyInfo() === true) {
          // 按钮 不可多次单击
          if (this.ableBottom === 0) return
          this.ableBottom = 0
          // 未登录状态 根据手机号
          var param = 'companyName=' + this.companyName + '&phone=' + this.phone +
            '&code=' + this.code + '&province=' + this.province +
            '&city=' + this.city + '&region=' + this.region + '&town=' + this.town +
            '&entRegionId=' + this.addressCode + '&address=' + this.detailAddress
          console.log(param)
          // return
          this.utils.GET(this.accountUrl + '/riskevalNew/getUserDataByPhone?' + param, function (response) {
            let code = parseInt(response.code)
            _this.getInfo()
            if (code === 0) {
              _this.ableBottom = 0
              let idCard = response.data.real_idcard
              if (_this.utils.isNull(idCard)) {
                console.log('初次评测111222=====1====================' + idCard)
                _this.$router.push({ path: 'evaluate-category2' })
              } else { // 开始评测
                console.log('初次评测111222======2===================' + idCard)
                _this.startRise(response.data)
              }
            } else {
              _this.ableBottom = 1
            }
            if (code === 50001) { // 存在未完成的评测
              // 弹出 继续评测
              _this.questionProgress()
            }
            if (code === 50003) { // 一个月只能评测一次 未登录状态
              // 弹出 继续评测
              _this.resultId = response.data.id
              if (parseInt(response.data.perfect_status) === 0) { // 0 不完美 1 完美
                _this.alerViewTitle = '每月仅限评测一次，请依据上次评测结果立即整改。'
              } else {
                _this.alerViewTitle = '评测一个月有效，是否查看评测结果？'
              }
              _this.riseProgress = 4
              _this.showAlert = true
              _this.alertSureTitle = '前往查看'
            }
            if (code === 50007) { // 企业名称认证失败

            }
            if (code === 50008) { // 公司已被实名认证

            }
          })
        }
      }
    },
    getInfo: function () {
      localStorage.setItem('isLogin', 1)
      var _this = this
      this.utils.GET(this.companyUrl + '/ent/json', function (data) {
        localStorage.setItem('userinfo', JSON.stringify(res.data))
      })
    },
    checkCompanyInfo: function () {
      if (this.showImage === true) {
        if (this.utils.isNull(this.imageUrl)) {
          Toast('请上传营业执照')
          return false
        }
      }
      if (this.utils.isNull(this.companyName)) {
        Toast('请输入企业名称')
        return false
      }
      if (this.utils.isNull(this.province) || this.utils.isNull(this.city) || this.utils.isNull(this.region)) {
        Toast('请输入企业所在地')
        return false
      }
      if (this.region === '下陆区') {
        if (this.utils.isNull(this.town)) {
          Toast('请选择所在街道')
          return false
        }
      }
      if (this.utils.isNull(this.detailAddress)) {
        Toast('请输入企业详细地址')
        return false
      }
      if (this.utils.isNull(this.phone)) {
        Toast('请输入联系人手机号')
        return false
      }
      if (!this.utils.isPhone(this.phone)) {
        Toast('请正确输入联系人手机号')
        return false
      }
      if (this.utils.isNumber(this.companyName)) {
        Toast('请正确输入企业名称')
        return false
      }
      if (this.isLogin === true) {
        if (this.binCode === false) {
          if (this.utils.isNull(this.code)) {
            Toast('请输入验证码')
            return false
          }
          if (this.code.length !== 6) {
            Toast('请正确输入验证码')
            return false
          }
        }
      }
      if (this.isLogin === false) {
        if (this.utils.isNull(this.code)) {
          Toast('请输入验证码')
          return false
        }
        if (this.code.length !== 6) {
          Toast('请正确输入验证码')
          return false
        }
      }
      return true
    },
    companyNameBlur: function () {
      this.blur()
      if (this.utils.isNull(this.companyName)) {
        return
      }
      this.checkCompanyName()
    },
    checkCompanyName: function () { // 未登录状态 查询企业信息
      var _this = this
      _this.phone = ''
      _this.fphone = ''
      // _this.address = ''
      _this.detailAddress = ''
      if (!_this.utils.isNull(_this.region)) {
        _this.binDetailAddress = false
      } else {
        _this.binDetailAddress = true
      }
      _this.binPhone = true
      // _this.haveTown = false
      this.utils.GET(this.accountUrl + '/riskeval/getUserDataByCompany?companyName=' + this.companyName, function (response) {
        // _this.binDetailAddress = true
        console.log('=======================有企业信息手机号======')
        let code = parseInt(response.code)
        let data = response.data
        if (code === 50007) { // 企业名称认证失败
          return
        }
        if (code === 50009) { // 企业识别异常，吊销、注销、清算、停止
          return
        }
        if (code === 0) {
          if (data.length > 1) {
            _this.time = 1
            for (let i = 0; i < response.data.length; i++) {
              let item = response.data[i]
              console.log('=================' + item.phone)
              console.log(item)
              if (_this.utils.isNull(item.phone)) {
                item.phone = '*****'
                item.fphone = '*****'
              }
              if (item.phone.length >= 11) {
                item.fphone = item.phone.substring(0, 3) + '*****' + item.phone.substring(8, 11)
              }
              item.haveAddress = false
              if (!_this.utils.isNull(item.province) && !_this.utils.isNull(item.city) && !_this.utils.isNull(item.region)) {
                item.haveAddress = true
                item.address = item.province + ' ' + item.city + ' ' + item.region
              } else {
                item.address = ''
              }
              item.haveTown = false
              if (!_this.utils.isNull(item.town)) {
                item.haveTown = true
              }
              console.log('000000========------------=======')
            }
            console.log(response.data)
            _this.companyNameData = response.data
            // 默认 第一项
            _this.currentIndex = 0
            // 设置 编辑状态
            _this.havePhone = true
            _this.haveAddress = true
            _this.setEditState()
          } else if (data.length === 1) {
            _this.time = 1
            _this.companyNameData = data
            // 默认 第一项
            _this.currentIndex = 0
            _this.havePhone = false
            _this.haveAddress = false
            // 设置 编辑状态
            _this.setEditState()
          } else {
            _this.companyNameData = []
            _this.havePhone = false
            _this.phone = ''
            _this.fphone = ''
            _this.binAddress = false
            _this.binPhone = false
          }
        }
      })
    },
    setEditState: function () { // 设置 查询企业信息的编辑转台
      let item = this.companyNameData[this.currentIndex]
      console.log(item)
      this.binPhone = false
      if (!this.utils.isNull(item.phone)) {
        this.phone = item.phone
        this.fphone = item.phone.substring(0, 3) + '*****' + item.phone.substring(8, 11)
        this.binPhone = true
        console.log('有手机号1================' + this.fphone)
      }
      this.binAddress = false
      this.address = ''
      if (!this.utils.isNull(item.province)) {
        this.province = item.province
        this.address = item.province
      }
      if (!this.utils.isNull(item.city)) {
        this.city = item.city
        this.address += (' ' + item.city)
      }
      if (!this.utils.isNull(item.region)) {
        this.region = item.region
        this.address += (' ' + item.region)
      }
      this.town = ''
      this.haveTown = false
      this.binTown = true
      if (item.region === '下陆区') {
        this.haveTown = true
        if (this.utils.isNull(item.town)) {
          this.binTown = false
        } else {
          this.town = item.town
        }
      }
      if (item.region === '西塞山区') {
        this.haveTown = true
        this.Town = 2
        if (this.utils.isNull(item.town)) {
          this.binTown = false
        } else {
          this.town = item.town
        }
      }

      console.log('地址================' + this.address)
      if (!this.utils.isNull(item.province) && !this.utils.isNull(item.city) && !this.utils.isNull(item.region)) {
        this.binAddress = true
      }
      this.binDetailAddress = false
      if (!this.utils.isNull(item.address)) {
        this.detailAddress = item.address
        this.binDetailAddress = true
      }
      console.log('设置状态=======================')
    },
    alertViewClick: function (index) {
      this.showAlert = false
      let userinfo = JSON.parse(localStorage.getItem('userinfo'))
      if (index === 1) {
        // if (this.riseProgress === 0) {
        //   this.$router.push({ path: 'evaluate-company' })
        // }
        if (this.riseProgress === 1) {
          this.$router.push({ path: 'evaluate-category2' })
        }
        if (this.riseProgress === 2) {
          this.$router.push({ path: 'fxcp_changsuo', query: { phoneNumber: userinfo.tails.userinfo[0].phone } })
          // this.$router.push({ path: 'evaluate-question', query: { categoryIds: this.unfinishedCategoryIds } })
        }
        if (this.riseProgress === 3) {
          this.$router.push({ path: 'fxcp_changsuo', query: { phoneNumber: userinfo.tails.userinfo[0].phone } })
          // this.$router.push({ path: 'evaluate-question-risk' })
        }
        if (this.riseProgress === 4) {
          this.$router.push({ path: 'fxcp_result', query: { resultId: this.resultId } })
        }
      }
    },
    alertViewClick2: function (index) {
      this.showAlert2 = false
      if (index === 1) { // 重现上传
        this.showImage = true
      } else { // 手动输入
        this.showImage = false
        this.binCompanyName = false
      }
    },
    showComImage: function () {
      this.showImage = true
      this.binCompanyName = true
    },
    showExampleImageClick: function () {
      this.imageVisible = true
    },
    closeExampleImageClick: function () {
      this.imageVisible = false
    },
    questionProgress: function () { // 查询 答题 进度
      console.log('获取答题进度 ==============================')
      var _this = this
      let userinfo = JSON.parse(localStorage.getItem('userinfo'))
      console.log(userinfo)
      this.utils.GETHeader(this.accountUrl + '/riskeval/getProgress', { 'phone': userinfo.tails.userinfo[0].phone }, function (response) {
        let data = response.data
        if (data === null) {
          _this.riseProgress = 0
          _this.$router.push({ path: 'evaluate-company' })
          return
        }
        if (data !== null) {
          console.log('评测进度 =====================')
          // progress 0 初始化,提交了企业信息,点击开始评测 未选择场所  1 完成二级答题 2 完成三级答题 3 完成评测 4 完成所有 分类答题
          _this.resultId = data.result_id
          let progress = data.progress
          if (progress === 0) {
            if (data.tails.siteCategoryList !== null && data.tails.siteCategoryList.length > 0) { // 已经选择 分类
              var categoryIds = ''
              for (let i = 0; i < data.tails.siteCategoryList.length; i++) {
                let catItem = data.tails.siteCategoryList[i]
                //  status 1 完成答题 2 未答题
                if (catItem.tails.status === 0) {
                  categoryIds += (catItem.id + ',')
                }
              }
              // 有未完成的分类 答题
              if (categoryIds.length > 0) {
                if (categoryIds.indexOf(',') >= 0) {
                  categoryIds = categoryIds.slice(0, categoryIds.length - 1)
                }
                // 提示有 未完成答题 提示 继续答题
                console.log('有未完成的评测 去完成=====================')
                _this.unfinishedCategoryIds = categoryIds
                _this.showAlert = true
                _this.alerViewTitle = '您有尚未完成的评测'
                _this.alertSureTitle = '前往完成'
                _this.riseProgress = 2
              }
            } else {
              console.log('未选择场所 选择场所=====================')
              _this.showAlert = true
              _this.alerViewTitle = '您有尚未完成的评测'
              _this.alertSureTitle = '前往完成'
              _this.riseProgress = 1
            }
          }
          if (progress === 4) { // 新版 完成所有 分类答题 - 》 跳转风险 评测答题
            console.log('未完成 最后的风险评测 =====================')
            _this.riseProgress = 3
            _this.showAlert = true
            _this.alerViewTitle = '您有尚未完成的评测'
            _this.alertSureTitle = '前往完成'
            return
          }
          // 查看评测结果
          if (progress === 3) {
            // 已经 有评测结果  是否 已满一个月  0 已满 可继续评测  1 未满 查看评测结果
            let repeat = data.tails.repeat
            if (repeat === 0) {
              console.log('已满一个月 重新评测==========' + repeat)
              _this.riseProgress = 0
            }
            if (repeat === 1) { // 不可评测
              console.log('未满一个月 查看评测结果==========' + repeat)
              if (parseInt(data.tails.perfect_status) === 0) { // 0 不完美 1 完美
                _this.alerViewTitle = '每月仅限评测一次，请依据上次评测结果立即整改。'
              } else {
                _this.alerViewTitle = '评测一个月有效，是否查看评测结果？'
              }
              _this.riseProgress = 4
              _this.showAlert = true
              _this.alertSureTitle = '前往查看'
            }
          }
        }
      })
    },
    loadData: function () {
      var _this = this
      // 手机 ip定位
      this.utils.GET(_this.accountUrl + '/riskevalNew/getUserData', function (response) {
        if (response.data.areaCode !== undefined) {
          _this.region = response.data.areaCode.label
        }
        if (response.data.cityCode !== undefined) {
          _this.city = response.data.cityCode.label
        }
        if (response.data.proinceCode !== undefined) {
          _this.province = response.data.proinceCode.label
          _this.address = _this.province + ' ' + _this.city + ' ' + _this.region
          _this.town = ''
          if (_this.region === '下陆区') {
            _this.haveTown = true
            if (_this.userCompanyData.town !== undefined) {
              _this.town = _this.userCompanyData.town
            }
            if (!_this.utils.isNull(_this.town)) {
              console.log('禁止街道----' + _this.town)
              _this.binTown = true
            }
          }
          if (_this.region === '西塞山区') {
            _this.haveTown = true
            _this.Town = 2
            if (_this.userCompanyData.town !== undefined) {
              _this.town = _this.userCompanyData.town
            }
            if (!_this.utils.isNull(_this.town)) {
              console.log('禁止街道----' + _this.town)
              _this.binTown = true
            }
          }
          _this.binAddress = false
        }
      })
      // 企业 资质认证配置
      this.utils.GET(_this.accountUrl + '/riskeval/getBusLicenseConfig', function (response) {
        let closed = parseInt(response.data.aliConfig.closed)
        _this.closeImage = closed
        // 如果是登陆状态，根据登陆的用户查询评测的基本企业信息
        _this.utils.isUserLogin(function (login) {
          console.log('==========' + login)
          // if (closed === 1) { // 关闭
          //   // 已认证企业
          //   _this.showImage = false
          // } else {
          //   _this.showImage = true
          // }
          if (login === 1) { // 登录状态
            _this.isLogin = true
            _this.binCode = true
            // 风险评测 进度
            _this.bottomStates = 1
            _this.questionProgress()
            // 获取 登录 用户信息
            _this.loadUserData()
            // 查询当前登陆用户是否企业认证
            _this.loadUserCompanyAuth()
          } else { // 未登录状态
            _this.isLogin = false

            // 先选择 营业执照 其他都不可输入
            _this.binCompanyName = true
            _this.binAddress = true
            _this.binPhone = true
            // _this.binCode = false
            _this.binImage = false
            if (closed === 1) { // 关闭
              _this.binCompanyName = false
            }
          }
        })
      })
    },
    loadUserData: function () { // 登录状态 查询营业执照
      var _this = this
      this.utils.GET(this.accountUrl + '/riskeval/getUserData', function (response) {
        _this.userCompanyData = response.data
        console.log(_this.userCompanyData)
        _this.binCompanyName = false
        if (!_this.utils.isNull(_this.userCompanyData.company_name)) { // 有企业名称 不可修改
          _this.companyName = _this.userCompanyData.company_name
          _this.binCompanyName = true
        }
        _this.binAddress = false
        _this.binTown = false
        if (!_this.utils.isNull(_this.userCompanyData.province) &&
          !_this.utils.isNull(_this.userCompanyData.city) &&
          !_this.utils.isNull(_this.userCompanyData.region)) { // 有地址信息 不可修改
          _this.province = _this.userCompanyData.province
          _this.city = _this.userCompanyData.city
          _this.region = _this.userCompanyData.region
          _this.address = _this.province + ' ' + _this.city + ' ' + _this.region
          _this.town = ''
          if (_this.region === '下陆区') {
            _this.haveTown = true
            if (_this.userCompanyData.town !== undefined) {
              _this.town = _this.userCompanyData.town
            }
            if (!_this.utils.isNull(_this.town)) {
              console.log('禁止街道----' + _this.town)
              _this.binTown = true
            }
          }
          if (_this.region === '西塞山区') {
            _this.haveTown = true
            _this.Town = 2
            if (_this.userCompanyData.town !== undefined) {
              _this.town = _this.userCompanyData.town
            }
            if (!_this.utils.isNull(_this.town)) {
              console.log('禁止街道----' + _this.town)
              _this.binTown = true
            }
          }
          _this.binAddress = true
        } else {
          _this.bottomStates = 0
        }
        _this.binDetailAddress = false
        if (!_this.utils.isNull(_this.userCompanyData.address)) { // 有地址信息 不可修改
          _this.detailAddress = _this.userCompanyData.address
          _this.binDetailAddress = true
        }
        _this.binPhone = false
        if (!_this.utils.isNull(_this.userCompanyData.phone)) { // 有企业名称 不可修改
          _this.phone = _this.userCompanyData.phone
          _this.fphone = _this.userCompanyData.phone.substring(0, 3) + '*****' + _this.userCompanyData.phone.substring(8, 11)
          _this.time = 0
          _this.binPhone = true
        }
      })
    },
    loadUserCompanyAuth: function () { // 登录状态 查询营业执照
      var _this = this
      this.utils.GET(_this.accountUrl + '/riskeval/getUserCompanyAuth', function (response) {
        let data = response.data
        if (!_this.utils.isNull(data.sign.sign_file)) {
          _this.imageUrl = data.sign.sign_file
          // 已认证企业
          _this.binImage = true
        }
      })
    },
    loadBaidu: function () { // 百度统计
      // var _hmt = _hmt || [];
      (function () {
        var hm = document.createElement('script')
        hm.src = 'https://hm.baidu.com/hm.js?87fb13ec56cc4f384472c97e55f4bcdf'
        var s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(hm, s)
      })()
    }
  }
}
</script>

<style scoped>
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
.wrapper {
  /*background-color: #f4f4f4;*/
  background-color: #ffffff;
  height: 100%;
  margin-top: 55px;
  /*padding-bottom: 65px;*/
  min-height: 400px;
}
.section {
  position: relative;
  width: 100%;
  background-color: #ffffff;
  /*margin-bottom: 10px;*/
  border-bottom: solid 10px #f4f4f4;
  box-sizing: border-box;
}
.section3 {
  border-bottom: solid 0px #f4f4f4;
}
.section .title {
  height: 50px;
  line-height: 50px;
  color: #000;
  font-size: 16px;
  font-weight: bold;
  margin-left: 15px;
}
.section3 .title {
  width: 65px;
  border-bottom: solid 3px #c41335;
  box-sizing: border-box;
}
.section3 .rightBtn {
  position: absolute;
  top: 0px;
  right: 15px;
  height: 50px;
  line-height: 50px;
  color: #c41335;
  font-size: 13px;
}
.section1 {
  height: 60px;
}
.section2 {
  height: 74px;
}
.section2 .image {
  width: 100%;
  height: 74px;
  background-image: url("../assets/icon_evaluate.jpg");
  background-size: cover;
  background-position: center center;
}
.section3 {
  height: 360px;
  /*height: 230px;*/
}
.section .box {
  position: relative;
  width: 100%;
  height: 45px;
  /*border-top: solid 1px #EEEEEE;*/
  /*border-bottom: solid 1px #EEEEEE;*/
  /*box-sizing: border-box;*/
  font-size: 14px;
  color: #000;
  border-top: solid 1px #eeeeee;
  box-sizing: border-box;
}
.section3 .box:last-child {
  border-bottom: solid 1px #eeeeee;
  box-sizing: border-box;
}
.section .box .tip {
  position: absolute;
  left: 15px;
  height: 45px;
  line-height: 45px;
}
.section .box input {
  position: absolute;
  top: 7px;
  height: 30px;
  line-height: 30px;
  left: 120px;
  right: 15px;
  border: none;
  box-sizing: border-box;
  color: #000000;
  /*background-color: #FFEECC;*/
}
.section3 .box1 {
  position: relative;
  height: 130px;
}
.section3 .box1 .input-image {
  position: absolute;
  top: 45px;
  left: 15px;
  width: 70px;
  height: 70px;
  background-color: yellow;
  opacity: 0;
  z-index: 1;
}
.section3 .box1 .image {
  position: absolute;
  top: 45px;
  left: 15px;
  width: 70px;
  height: 70px;
  background-image: url(../assets/addphoto.png);
  background-size: cover;
  background-position: center center;
  z-index: 0;
}
.section3 .box1 .tip2 {
  position: absolute;
  top: 45px;
  left: 100px;
  right: 15px;
  height: 50px;
  font-size: 12px;
  line-height: 16px;
  color: #bebebe;
}
.section3 .box1 .tip2 span {
  color: #c41335;
}
.section3 .box1 .example {
  position: absolute;
  left: 100px;
  top: 100px;
  right: 15px;
  height: 15px;
}
.section3 .box1 .example img {
  position: absolute;
  top: 1px;
  width: 12px;
  height: 12px;
}
.section3 .box1 .example span {
  position: absolute;
  top: 0px;
  left: 17px;
  height: 15px;
  line-height: 15px;
  font-size: 12px;
  color: #c41335;
}
.address-menu {
  margin-left: 120px;
  width: calc(100% - 120px);
  height: 40px;
}
.address-menu a {
  position: relative;
  top: 0px;
  width: 100%;
  height: 40px;
  line-height: 40px;
  color: #000000;
  /*background-color: yellow*/
}
.phone-menu {
  margin-left: 120px;
  width: calc(100% - 120px);
  height: 40px;
}
.phone-menu a {
  position: relative;
  top: 0px;
  width: 100%;
  height: 40px;
  line-height: 40px;
  color: #000000;
  /*background-color: yellow*/
}
.section .box .codebtn {
  position: absolute;
  top: 9px;
  right: 13px;
  width: 85px;
  height: 27px;
  line-height: 27px;
  color: white;
  text-align: center;
  background: #c41335;
  border-radius: 27px;
  box-sizing: border-box;
  text-align: center;
}
.image-popup {
  position: center;
  width: 320px;
  height: 435px;
}
image-example {
  position: relative;
  margin: 0px;
  height: 435px;
  background-color: yellowgreen;
}
.e-image {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  width: 100%;
  height: 435px;
}
.e-image img {
  position: absolute;
  top: 0px;
  width: 320px;
  height: 435px;
}
.e-image-close {
  position: absolute;
  top: 13px;
  right: 15px;
  width: 16px;
  height: 16px;
  background-image: url(../assets/icon-close-w.png);
  background-size: cover;
  background-position: center center;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/view/evaluate-company.vue